import { CoreButton, CoreModalDialogFooter } from '@components'
import WarningIcon from '@images/icons/warning-orange.svg?react'
import { GlobalContext, tr } from 'mmfintech-commons'
import { useContext } from 'react'

import styles from './SoleTraderInfoModal.module.scss'

interface SoleTraderInfoModalProps {
  onConfirm: () => void
}

export const SoleTraderInfoModal = ({ onConfirm }: SoleTraderInfoModalProps) => {
  const { modalHide } = useContext(GlobalContext)

  const appliesItems = [
    tr(
      'FRONTEND.SIGNUP.SOLE_TRADER.APPLIES_1',
      'You are the sole owner of your business with no directors or shareholders'
    ),
    tr('FRONTEND.SIGNUP.SOLE_TRADER.APPLIES_2', 'Your business has no separate legal structure or corporate entity'),
    tr('FRONTEND.SIGNUP.SOLE_TRADER.APPLIES_3', 'You may employ staff, but you personally own and operate the business')
  ]

  const notAppliesItems = [
    tr(
      'FRONTEND.SIGNUP.SOLE_TRADER.NOT_APPLIES_1',
      'Your business is registered as an LLC, Ltd, or any other incorporated company'
    ),
    tr('FRONTEND.SIGNUP.SOLE_TRADER.NOT_APPLIES_2', 'You are the sole shareholder or director of a registered company')
  ]

  const handleConfirm = () => {
    onConfirm()
    modalHide()
  }

  return (
    <div className={styles['sole-trader-info-modal']} data-test='sole-trader-info-modal'>
      <p className='sole-trader-info-intro'>
        {tr(
          'FRONTEND.SIGNUP.SOLE_TRADER.DESCRIPTION_SUBTITLE',
          'Select this if you operate your business as an individual, do not have a registered company, and you and your business are legally the same person.'
        )}
      </p>

      <div className='sole-trader-info-section'>
        <span className='sole-trader-info-section-label'>
          {tr('FRONTEND.SIGNUP.SOLE_TRADER.APPLIES_TITLE', 'This applies to you if')}
        </span>
        {appliesItems.map((item, index) => (
          <div className='sole-trader-info-item' key={`applies-${index}`}>
            <span className='sole-trader-info-dot sole-trader-info-dot-red' />
            <span className='sole-trader-info-item-text'>{item}</span>
          </div>
        ))}
      </div>

      <div className='sole-trader-info-section'>
        <span className='sole-trader-info-section-label'>
          {tr('FRONTEND.SIGNUP.SOLE_TRADER.NOT_APPLIES_TITLE', 'This does not apply to you if')}
        </span>
        {notAppliesItems.map((item, index) => (
          <div className='sole-trader-info-item' key={`not-applies-${index}`}>
            <span className='sole-trader-info-dot sole-trader-info-dot-muted' />
            <span className='sole-trader-info-item-text'>{item}</span>
          </div>
        ))}
      </div>

      <div className='sole-trader-info-warning'>
        <WarningIcon className='sole-trader-info-warning-icon' />
        <span className='sole-trader-info-warning-text'>
          {tr(
            'FRONTEND.SIGNUP.SOLE_TRADER.WARNING',
            'If you need to change or remove the Sole Trader status after completing onboarding, you will be required to go through the onboarding process again.'
          )}
        </span>
      </div>

      <CoreModalDialogFooter>
        <div className='sole-trader-info-footer'>
          <CoreButton
            type='button'
            size='large'
            fullWidth
            variation='primary'
            text={tr('FRONTEND.SIGNUP.SOLE_TRADER.CONFIRM', 'Confirm — I am a Sole Trader')}
            onClick={handleConfirm}
            data-test='sole-trader-confirm'
          />
          <CoreButton
            type='button'
            size='large'
            fullWidth
            variation='tertiary'
            text={tr('FRONTEND.BUTTONS.CANCEL', 'Cancel')}
            onClick={() => modalHide()}
            data-test='sole-trader-cancel'
          />
        </div>
      </CoreModalDialogFooter>
    </div>
  )
}
